import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  // Disable browser scroll restoration so route changes always start at top.
  // (Fixes cases where the browser keeps the previous scroll position.)
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const apply = () => {
      // Ensure both doc + body scroll are reset (some browsers use body, others docElement).
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    };

    apply();
    // Wait a tick for layout/images to settle, then re-apply.
    requestAnimationFrame(apply);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
